import styled, { css } from 'styled-components';
import { media } from '@simplywallst/ui-core';

export const roleColorSVG = css`
  > * {
    fill: ${({ theme }) => theme.color.white};
    opacity: 0.3;
  }
`;

const RolesBase = css`
  > svg {
    ${roleColorSVG}
    vertical-align: middle;
    margin-top: -2px;
    margin-left: ${({ theme }) => theme.x1spacePx / 2}px;
    &:first-child {
      margin-left: 0;
    }
  }
`;

export const RolesWithTooltipWrapper = styled('span')`
  ${RolesBase}
  ${media.mdDown`
    display: none;
  `}
`;

export const RolesWrapper = styled('span')`
  ${RolesBase}
  ${media.smUp`
    display: none;
  `}
`;
